export const removeEmptyArrays = (obj) => {
  // Handle null, undefined, or non-object inputs
  if (obj === null || obj === undefined) {
    return {};
  }

  // Handle non-object types (primitives, arrays, etc.)
  if (typeof obj !== "object" || Array.isArray(obj)) {
    return {};
  }

  try {
    return Object.fromEntries(
      Object.entries(obj).filter(([key, value]) => {
        // Keep the entry if it's not an array, or if it's a non-empty array
        return !Array.isArray(value) || value.length > 0;
      })
    );
  } catch (error) {
    // Fallback in case of any unexpected errors
    console.warn("Error removing empty arrays:", error);
    return {};
  }
};
